import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Uploads a ledger Excel/PDF file for an entity.
 * POST api/Onboarding/upload-excel
 * Form fields: EntityId, File
 *
 * @param {{ entityId: string, file: File }} params
 * @returns {{ success: boolean, data?: object, error?: string }}
 */
export const uploadExcelAction = async ({ entityId, file }) => {
  try {
    const formData = new FormData();
    formData.append("EntityId", entityId || "");
    formData.append("File", file);

    const response = await apiClient.post(ATP_API_URL.UPLOAD_EXCEL, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response?.status === 200) {
      return { success: true, data: response.data };
    }
    return { success: false, error: "Upload failed" };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
